var createExamFrame = function () {
    var str = '<div class="modal-dialog" role="document">' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
        '<h4 class="modal-title" id="myModalLabel">Create Exam</h4>' +
        '</div><!-- modal-header -->' +
        '<div class="modal-body">' +
        '<div class="form-group">' +
        '<label for="select-exam">Select Exam Type</label>' +
        '<select class="form-control" id="select-exam">' +
        '<option value="">Select One</option>' +
        /* JayG Jul 22, 2022 - #22450585 - Select which exam to practice - Basic, Core, Applied */
        '<option value="Basic">Basic</option>' +
        '<option value="Core">Core</option>' +
        '<option value="Applied">Applied</option>' +
        /* end JayG */
        // '<option value="Written">Written Multiple Choice</option>' +
        // '<option value="Pathology">Dermatopathology</option>' +
        // '<option value="Kodachromes I">Kodachromes Part I</option>' +
        // '<option value="Kodachromes II">Kodachromes Part II</option>' +
        /* JayG Jul 22, 2022 - ##22450585 - Select which exam to practice - Basic, Core, Applied */
        '</select></div><!-- form-group -->' +
        '<div class="form-group hidden" id="exam-module-block">' +
        '<label for="select-module">Select Exam Module</label>' +
        '<select class="form-control" id="select-module">' +
        '<option value="">Select One</option>' +
        '<option value="Medical Dermatology">Medical Dermatology</option>' +
        '<option value="Surgical Dermatology">Surgical Dermatology</option>' +
        '<option value="Pediatric Dermatology">Pediatric Dermatology</option>' +
        '<option value="Dermatopathology">Dermatopathology</option>' +
        // '<option value="Written">Written Multiple Choice</option>' +
        // '<option value="Pathology">Dermatopathology</option>' +
        /* end JayG */
        // '<option value="Kodachromes I">Kodachromes Part I</option>' +
        // '<option value="Kodachromes II">Kodachromes Part II</option>' +
        '</select></div><!-- form-group -->' +
        '</div><!-- modal-body -->' +
        '<div class="modal-footer">' +
        '<div class="form-group"><button type="button" class="btn btn-default" id="create-exam-button">Create and GO!</button></div>' +
        '</div>' +
        '</div><!-- modal-content -->' +
        '</div><!-- modal-dialog -->';
    return $.parseHTML(str);
}
module.exports = createExamFrame;


//////////////////
// WEBPACK FOOTER
// ./src/create_exam_frame.js
// module id = 301
// module chunks = 0